import * as React from 'react'
import { Box, Popover, Icon, Tooltip } from '@design/pt-ui'
import CopyToClipboard from 'react-copy-to-clipboard'
import { ReactChildren } from '../types/react'

interface IProps {
  activator: any
  value?: any
  children: ReactChildren
}

interface IState {
  anchorEl: any
}

function PopoverWithClipboardCopy(props: IProps) {
  const [state, setState] = React.useState<IState>({
    anchorEl: null,
  })

  const copyToClipboard = () => {
    setState({ anchorEl: null })
  }

  const handleOpen = (e: any) => {
    setState({ anchorEl: e.currentTarget })
  }

  const handleClose = () => {
    setState({ anchorEl: null })
  }

  return (
    <>
      <div onMouseOver={handleOpen}>{props.activator}</div>
      <Popover
        open={state.anchorEl !== null}
        anchorEl={state.anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}>
          <div>{props.children}</div>
          <CopyToClipboard text={props.value} onCopy={copyToClipboard}>
            <span>
              <Tooltip title="Copy" placement="bottom">
                <Icon sx={{ ml: 1, cursor: 'pointer' }}>file_copy</Icon>
              </Tooltip>
            </span>
          </CopyToClipboard>
        </Box>
      </Popover>
    </>
  )
}

export default PopoverWithClipboardCopy
